(function () {
  if (customElements.get("pdp-upsell")) return;

  class PdpUpsell extends HTMLElement {
    connectedCallback() {
      this._currency = this.dataset.currency || "EUR";
      this._locale = this.dataset.locale || "de-DE";
      this._priceFormatter = new Intl.NumberFormat(this._locale, {
        style: "currency",
        currency: this._currency,
      });

      this.addEventListener("change", this._onChange.bind(this));
      this.addEventListener("click", this._onClick.bind(this));

      this._onCartUpdated = this._onCartUpdated.bind(this);
      document.documentElement.addEventListener("cart:updated", this._onCartUpdated);
      document.documentElement.addEventListener("variant:added", this._onCartUpdated);
    }

    disconnectedCallback() {
      document.documentElement.removeEventListener("cart:updated", this._onCartUpdated);
      document.documentElement.removeEventListener("variant:added", this._onCartUpdated);
    }

    _rows() {
      return Array.from(this.querySelectorAll(".pdp-upsell-product-row"));
    }

    _rowForProduct(productId) {
      return this.querySelector(`.pdp-upsell-product-row[data-product-id="${productId}"]`);
    }

    _setRowInCart(row, inCart) {
      if (!row) return;
      row.classList.toggle("pdp-upsell-product-row--in-cart", inCart);
      const addEl = row.querySelector("[data-pdp-upsell-add]");
      const inCartEl = row.querySelector("[data-pdp-upsell-in-cart]");
      if (addEl) addEl.hidden = inCart;
      if (inCartEl) inCartEl.hidden = !inCart;
    }

    _applyVariant(row, swatch) {
      if (!row || !swatch) return;

      const variantId = swatch.dataset.variantId;
      const price = swatch.dataset.price;
      const label = swatch.dataset.label;
      const imageUrl = swatch.dataset.imageUrl;

      row.dataset.variantId = variantId;

      const priceEl = row.querySelector("[data-pdp-upsell-price]");
      if (priceEl && price) {
        priceEl.textContent = this._priceFormatter.format(parseInt(price, 10) / 100);
      }

      const labelEl = row.querySelector("[data-pdp-upsell-variant-label]");
      if (labelEl && label) {
        labelEl.textContent = label;
      }

      const imageEl = row.querySelector("[data-pdp-upsell-image]");
      if (imageEl && imageUrl) {
        imageEl.src = imageUrl;
      }
    }

    _onChange(event) {
      const swatch = event.target.closest("[data-pdp-upsell-swatch]");
      if (!swatch || !this.contains(swatch)) return;

      const row = swatch.closest(".pdp-upsell-product-row");
      this._applyVariant(row, swatch);
    }

    async _onClick(event) {
      const atcBtn = event.target.closest("[data-pdp-upsell-atc]");
      if (!atcBtn || !this.contains(atcBtn)) return;

      event.preventDefault();

      const row = atcBtn.closest(".pdp-upsell-product-row");
      if (!row || row.classList.contains("pdp-upsell-product-row--in-cart")) return;

      const variantId = row.dataset.variantId;
      if (!variantId) return;

      const addVariantToCart = window.ThemeCore?.ATC?.addVariantToCart;
      if (typeof addVariantToCart !== "function") return;

      atcBtn.setAttribute("aria-busy", "true");
      atcBtn.disabled = true;

      try {
        await addVariantToCart(variantId, 1, { openMiniCart: false });
        this._setRowInCart(row, true);
      } catch (error) {
        console.error("[pdp-upsell] Add to cart failed:", error);
        const showError = window.ThemeCore?.ATC?.showCartAjaxError;
        if (typeof showError === "function") {
          showError(row, error?.message, atcBtn);
        }
      } finally {
        atcBtn.removeAttribute("aria-busy");
        atcBtn.disabled = false;
      }
    }

    _onCartUpdated(event) {
      const cart = event.detail?.cart;
      if (!cart?.items?.length) return;

      const productIds = new Set(cart.items.map((item) => String(item.product_id)));

      this._rows().forEach((row) => {
        const productId = row.dataset.productId;
        if (productIds.has(String(productId))) {
          this._setRowInCart(row, true);
        }
      });
    }
  }

  customElements.define("pdp-upsell", PdpUpsell);
})();
